const CONNECT_URL = {
  ebay: "https://www.ebay.com/",
  etsy: "https://www.etsy.com/",
  amazon: "https://sellercentral.amazon.com/",
  walmart: "https://admin.shopify.com/",
  meesho: "https://supplier.meesho.com/",
  amazon_in: "https://sellercentral.amazon.in/",
  flipkart: "https://seller.flipkart.com/",
  myntra: "https://www.myntra.com/",
  ajio: "https://www.ajio.com/",
  nykaa: "https://www.nykaafashion.com/",
  tatacliq: "https://www.tatacliq.com/",
  olx: "https://www.olx.in/",
  mercari: "https://www.mercari.com/",
  grailed: "https://www.grailed.com/",
  poshmark: "https://poshmark.com/",
  facebook: "https://www.facebook.com/marketplace",
  depop: "https://www.depop.com/",
};

const TILES = [
  { id: "ebay", name: "eBay" },
  { id: "etsy", name: "Etsy" },
  { id: "amazon", name: "Amazon" },
  { id: "walmart", name: "Shopify" },
  { id: "meesho", name: "Meesho" },
  { id: "amazon_in", name: "Amazon.in" },
  { id: "flipkart", name: "Flipkart" },
  { id: "myntra", name: "Myntra" },
  { id: "ajio", name: "AJIO" },
  { id: "nykaa", name: "Nykaa Fashion" },
  { id: "tatacliq", name: "Tata CLiQ" },
  { id: "olx", name: "OLX" },
  { id: "mercari", name: "Mercari" },
  { id: "grailed", name: "Grailed" },
  { id: "poshmark", name: "Poshmark" },
  { id: "facebook", name: "Facebook" },
  { id: "depop", name: "Depop" },
];

export function MarketLogo({ id }) {
  if (id === "ebay") {
    return (
      <svg viewBox="0 0 72 28" className="w-[70%] h-auto" aria-hidden>
        <text x="0" y="22" fontFamily="Arial Black, Arial, sans-serif" fontSize="22" fontWeight="800">
          <tspan fill="#E53238">e</tspan>
          <tspan fill="#0064D2">B</tspan>
          <tspan fill="#F5AF02">a</tspan>
          <tspan fill="#86B817">y</tspan>
        </text>
      </svg>
    );
  }
  if (id === "etsy") {
    return (
      <svg viewBox="0 0 64 28" className="w-[58%] h-auto" aria-hidden>
        <text x="0" y="22" fill="#F1641E" fontFamily="Georgia, serif" fontSize="22" fontWeight="700">Etsy</text>
      </svg>
    );
  }
  if (id === "amazon") {
    return (
      <svg viewBox="0 0 90 32" className="w-[78%] h-auto" aria-hidden>
        <text x="4" y="18" fill="#111" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="700">amazon</text>
        <path d="M18 24c10 6 28 6 42-1" fill="none" stroke="#FF9900" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M58 21l5 3-6 2" fill="none" stroke="#FF9900" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (id === "walmart") {
    return (
      <svg viewBox="0 0 88 28" className="w-[78%] h-auto" aria-hidden>
        <text x="0" y="20" fill="#96BF48" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="700">Shopify</text>
      </svg>
    );
  }
  if (id === "meesho") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#F43397" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="800">M</text>
      </svg>
    );
  }
  if (id === "amazon_in") {
    return (
      <svg viewBox="0 0 90 32" className="w-[78%] h-auto" aria-hidden>
        <text x="4" y="16" fill="#111" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700">amazon.in</text>
        <path d="M16 22c8 5 24 5 36-1" fill="none" stroke="#FF9900" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    );
  }
  if (id === "flipkart") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#2874F0" />
        <text x="18" y="24" textAnchor="middle" fill="#FFE500" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="800">Fk</text>
      </svg>
    );
  }
  if (id === "myntra") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#FF3F6C" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="800">Myn</text>
      </svg>
    );
  }
  if (id === "ajio") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#C6A667" fontFamily="Georgia, serif" fontSize="11" fontWeight="700">AJIO</text>
      </svg>
    );
  }
  if (id === "nykaa") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#FC2779" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Georgia, serif" fontSize="10" fontWeight="700">Nykaa</text>
      </svg>
    );
  }
  if (id === "tatacliq") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#0B1D78" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="700">CLiQ</text>
      </svg>
    );
  }
  if (id === "olx") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#002F34" />
        <text x="18" y="24" textAnchor="middle" fill="#3A77FF" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="800">OLX</text>
      </svg>
    );
  }
  if (id === "mercari") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <circle cx="18" cy="18" r="16" fill="#FF0211" />
        <path d="M10 22c2.4-6 5.2-10 8-10s5.6 4 8 10" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      </svg>
    );
  }
  if (id === "grailed") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" fill="#111" />
        <text x="18" y="25" textAnchor="middle" fill="#fff" fontFamily="Georgia, serif" fontSize="20">G</text>
      </svg>
    );
  }
  if (id === "poshmark") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#C41E3A" />
        <text x="18" y="25" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="800">P</text>
      </svg>
    );
  }
  if (id === "facebook") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#1877F2" />
        <path d="M21 18h3l.5-3H21v-2c0-.9.3-1.5 1.6-1.5H25V8.2C24.5 8.1 23.3 8 22 8c-3.3 0-5.5 2-5.5 5.7V15H14v3h2.5v8H21v-8z" fill="#fff" />
      </svg>
    );
  }
  if (id === "depop") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="18" fill="#FF2300" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="800">@</text>
      </svg>
    );
  }
  if (id === "pinterest") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#E60023" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Georgia, serif" fontSize="18" fontWeight="700">P</text>
      </svg>
    );
  }
  if (id === "aliexpress") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#E62E04" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="800">Ali</text>
      </svg>
    );
  }
  if (id === "woocommerce") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#7F54B3" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="10" fontWeight="800">Woo</text>
      </svg>
    );
  }
  if (id === "wix") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">Wix</text>
      </svg>
    );
  }
  if (id === "bonanza") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#F26522" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="800">Bnz</text>
      </svg>
    );
  }
  if (id === "backmarket") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#78E08C" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">BM</text>
      </svg>
    );
  }
  if (id === "stockx") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#006340" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">SX</text>
      </svg>
    );
  }
  if (id === "goat") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">G</text>
      </svg>
    );
  }
  if (id === "discogs") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#FFD100" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="800">D</text>
      </svg>
    );
  }
  if (id === "abebooks") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#C8102E" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">Ab</text>
      </svg>
    );
  }
  if (id === "squarespace") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#111" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="800">Sq</text>
      </svg>
    );
  }
  if (id === "square") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#006AFF" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="800">S</text>
      </svg>
    );
  }
  if (id === "google_shopping") {
    return (
      <svg viewBox="0 0 36 36" className="w-10 h-10" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#4285F4" />
        <text x="18" y="24" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="800">GS</text>
      </svg>
    );
  }
  return null;
}

export { TILES, CONNECT_URL };

export function marketplaceConnectUrl(id) {
  return CONNECT_URL[id] || "";
}

export function MarketplaceTiles({ selected, onSelect, connected = {}, disabled = false }) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-x-4 gap-y-6 justify-items-center" data-testid="marketplace-tiles">
      {TILES.map((tile) => {
        const on = selected === tile.id;
        const isOn = Boolean(connected[tile.id]);
        return (
          <button
            key={tile.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(tile.id)}
            data-testid={`market-tile-${tile.id}`}
            className="group w-[88px] text-center disabled:opacity-50"
          >
            <span
              className={`relative mx-auto flex h-[76px] w-[76px] items-center justify-center rounded-[14px] bg-white shadow-sm transition-all ${
                on ? "ring-2 ring-aura-accent ring-offset-2 ring-offset-[#0b0b0e]" : "ring-1 ring-black/10"
              }`}
            >
              <MarketLogo id={tile.id} />
              {isOn && (
                <span className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-aura-accent text-white text-[10px] leading-5">✓</span>
              )}
            </span>
            <span className="mt-2 block text-[11px] text-aura-muted">{tile.name}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function ConnectPrimaryCard({
  selected,
  onSelect,
  onConfirm,
  onCreateItem,
  busy = false,
  connected = {},
}) {
  return (
    <div className="bg-[#0b0b0e] sm:bg-aura-surface border border-aura-border rounded-2xl px-6 sm:px-10 py-10 text-center" data-testid="connect-primary-card">
      <h1 className="text-[28px] sm:text-[32px] font-semibold tracking-tight mb-3">Connect Your Primary Marketplace</h1>
      <p className="text-sm text-aura-muted max-w-lg mx-auto mb-8 leading-relaxed">
        Your primary marketplace is the one with the most active inventory. We’ll need this to import your listings.
      </p>
      <MarketplaceTiles selected={selected} onSelect={onSelect} connected={connected} />
      <p className="text-xs text-aura-muted mt-6">Connect from Connections on eBay, Etsy, Depop, Amazon, Shopify, Flipkart, or helper shops like Poshmark.</p>
      <button
        type="button"
        disabled={busy || !selected}
        onClick={onConfirm}
        data-testid="connect-primary-confirm"
        className={`mt-8 w-full max-w-xs mx-auto py-3.5 rounded-full text-sm font-semibold ${
          selected && !busy ? "btn-accent" : "bg-[#3f3f46] text-white/70 cursor-not-allowed"
        }`}
      >
        Confirm
      </button>
      <p className="text-sm text-aura-muted mt-6">
        Don’t have inventory on any of these?{" "}
        <button type="button" onClick={onCreateItem} className="text-aura-cyan hover:underline" data-testid="connect-create-item">
          Create a new item
        </button>{" "}
        to start crosslisting!
      </p>
    </div>
  );
}
